module.exports = __webpack_public_path__ + "img/1.b9bf980a.jpg";